import React from 'react';

import PropTypes from 'prop-types';

import SearchBar from 'components/SearchBar';
import SearchInput from 'components/SearchBar/SearchInput';

const PeopleSearchBar = ({ onChange, children = null }) => {
  return (
    <div className="flex mb-4">
      <SearchBar>
        <SearchInput
          name="search_people"
          placeholder="Search People"
          delay={0}
          onChange={onChange}
        />
      </SearchBar>
      {children}
    </div>
  );
};

PeopleSearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default PeopleSearchBar;
